module.exports = __webpack_public_path__ + "static/media/tab_checkmark_icon_active.523b8b58.svg";